import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { FuseFullscreenModule } from '@fuse/components/fullscreen';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { BellNotifComponent } from 'app/layout/common/bell-notif/bell-notif.component';
import { FiltersModule } from 'app/layout/common/filters/filters.module';
import { LanguagesModule } from 'app/layout/common/languages/languages.module';
import { SettingsModule } from 'app/layout/common/settings/settings.module';
import { UserModule } from 'app/layout/common/user/user.module';
import { DenseLayoutComponent } from 'app/layout/layouts/vertical/dense/dense.component';
import { LoadingOverlayComponent } from 'app/shared/components/loading-overlay/loading-overlay';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [DenseLayoutComponent, LoadingOverlayComponent],
    imports: [
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenModule,
        FuseLoadingBarModule,
        FuseNavigationModule,
        LanguagesModule,
        UserModule,
        SettingsModule,
        FiltersModule,
        SharedModule,
        BellNotifComponent,
        MatProgressSpinnerModule,
    ],
    exports: [DenseLayoutComponent],
})
export class DenseLayoutModule {}
